import { useState } from 'react'

import styles from './styles.module.scss'

export default function Policies() {
  const [content, setContent] = useState(0);

  return (
    <div className={styles.policyWrapper}>
      <nav>
        <button onClick={() => {setContent(0)}}>Rules & Agreements</button>
        <button onClick={() => {setContent(1)}}>User Agreement</button>
        <button onClick={() => {setContent(2)}}>Terms & Conditions</button>
        <button onClick={() => {setContent(3)}}>Trust-Factor System</button>
        <button onClick={() => {setContent(4)}}>Advertising Policy</button>
      </nav>
      <div>
        { content === 0 && <RulesAndAgreements setContent={setContent} /> }
        { content === 1 && <UserAgreement /> }
        { content === 2 && <TermsAndConditions /> }
        { content === 3 && <TrustFactorSystem /> }
        { content === 4 && <AdvertisingPolicy /> }
      </div>
    </div>
  )
}


function RulesAndAgreements({ setContent }) {
  return(
    <div>
      <h1>Rules & Agreements</h1>
      <h2>Term #1:</h2>
      <p>
        Waco Exchange is a C2C (Customer-2-Customer) platform devised to help localize goods, services,
        and property between residents in Waco and the surrounding areas. Waco Exchange is not responsible for
        any form of transaction caused between exchangers on this platform,
        moreover, we're a hub for providing communication between exchangers.
      </p>
      <h2>Term #2:</h2>
      <p>Waco Exchange features a messaging system, which allows exchangers to transact goods, services, and property.
        Owners and employees of Waco Exchange view and monitor any messages that involve any form of illegal activity,
        or activity that is indecent. Any user activity that violates the laws of the United States will be reported to
        local authorities.
      </p>
      <p>Owners and employees of Waco Exchange bare the right to provide any information related to users violating
        the laws of the United States. This protects Waco Exchange and the online community of exchangers.
      </p>
      <h2>Term #3:</h2>
      <p>By using Waco Exchange, we collect data and information from users who register. Waco Exchange is not responsible
        for data breaches, or data leaks from our databases. However, Waco Exchange and all of it's employees as well as
        owners, will provide the best security possible for it's users and their data. Therefore, the owners and employees
        cannot be sued by any entity, as any user who registers on Waco Exchange is responsible for reading
        the Rues & Agreements, Privacy Policy, and the Terms & Conditions.
      </p>
      <h2>Term #4:</h2>
      <p>The goal of Waco Exchange is to provide a simple, straight forward, and trustworthy environment.
        Waco Exchange provides a Trust-Factor System (TFS), which is a judicial system within Waco Exchange's online community
        of users. Users will be able to view each other's profiles, presenting to them basic information about that
        user, their listings, statistics, star rating, and violations against that user.
      </p>
      <p>Users will abide by the Trust-Factor System (TFS) in order to bring
        security to the community of Waco Exchange.</p>
      <p><a onClick={(e) => { e.preventDefault(); setContent(3); } } >Learn more about the Trust-Factor System.</a></p>
    </div>
  )
}

function UserAgreement() {
  return(
    <div>
      <h1>User Agreement</h1>

      <h2>YOU MUST BE 18 YEARS OR OLDER TO REGISTER AND USE OUR PLATFORM</h2>

      <h2>General Use Provisions</h2>
      <p>All persons registering on this site unconditionally accept the following terms and conditions,
        all general terms and conditions of Waco Exchange,
        plus the specific terms and conditions for each individual listing/post as posted on this and associated websites.
        All buyers, sellers, and traders agree to abide by all such terms and conditions,
        fully and without recourse to any buyer, seller, or trader.</p>
      <p>This site is provided only as a venue for sellers, buyers, and traders. A seller is a person or entity who owns property and offers it for sale on WacoExchange.com. Waco Exchange is not a seller, is not involved in the actual transaction between these parties and assumes no control or liability over any issues that may arise as a result of this transaction. A contract is established only between the registered buyer and the seller/trader offering an item or items for sale or trade on WacoExchange.</p>

      <h2>Intellectual Property</h2>
      <p>All materials provided on this Website, including but not limited to information, documents, products, logos,
        graphics, images, listings, messages, and services are the wholly owned and copyrighted work of SITE OWNER and/or
        its Third Party Providers. None of the materials posted herein may be copied, scraped, reproduced,
        distributed, republished, downloaded, displayed, posted or transmitted in any form or by any means,
        including but not limited to electronic, mechanical, photocopying, recording,
        or other means, without the prior express written permission of Site Owner or the appropriate Third Party Provider.
        You may not "mirror" or scrape any materials contained on this Website,
        any other server or site without Site Owner's prior written consent.
        In order to register on this site you must provide your true name and a valid email address.
        <b>Buying/Selling/Trading participants are responsible for maintaining current, complete,
          and correct personal and business information in their registration file.</b></p>

      <h2>Terms of Services</h2>
      <p>This comprises the entire agreement between the User and Site OWNER and supersedes all other agreements.
        By registering and participating as a user you are indicating your consent to be bound by this agreement,
        the general terms and conditions of Waco Exchange, and the specific terms and condition for each listing
        as they are posted on the WacoExchange.com with Waco Exchange.</p>

      <h2>Disclaimer</h2>
      <p>Except as specified herein, the services on this website are provided solely on an "AS IS" basis.
        The site owner hereby disclaims all express or implied representations, warranties, guarantees, and conditions,
        including but not limited to any implied warranties or conditions of descriptions, quantities, merchantability,
        fitness for a particular purpose, title and non-infringement,
        except to the extent that such disclaimers are held to be legally invalid in your jurisdiction.
        Buyers/Traders assume all responsibility for determining whether the products/services are suitable and adequate
        for the purposes intended. Site owner does not make any representations, warranties, guaranties, or conditions
        as to the descriptions, quantities, quality, suitability, accuracy, or completeness of any of the products/services
        contained on the website.</p>
      <p>All items are sold AS IS, WHERE IS with NO warranties implied or expressed. No allowance, refund 
        or set aside will be made on account of any incorrectness, error in cataloging, 
        <b>description</b>, <b>quantity</b>, imperfection, defect or damage.
        Any descriptions or representations are for identification purposes only and are not to be construed as a
        warranty of any type. It is the responsibility of the Buyer to have inspected thoroughly the items and to have
        satisfied himself or herself as to its condition and value and to make an offer based upon that judgment solely.
        Any discrepancy with any item description or vehicle paperwork must be dealt directly with the SELLER
        listed above and not Waco Exchange. All participants hereby agree and accept that WacoExchange.com will not
        be held responsible for any errors in descriptions of any participant(s) for any reason whatsoever.</p>

      <h2>Limitation of Liability</h2>
      <p>The site owner shall not be liable for any direct or indirect damages suffered as a result of
        purchasing or selling items on this website. In no event shall site owner be liable for any direct,
        indirect, punitive, special, incidental, or consequential damages (including but not limited to loss of
        business, revenue, profits, use, data or other economic advantage), however arising, whether in an action of
        contract, negligence or other tortious action, arising out of or in connection with the use or performance of
        information available from this website, even if site owner has been previously advised of the possibility of
        such damage. Buyers/Traders agree to hold site owner harmless from liability from any damage, injury or loss,
        and covenants not to take any legal or other action against site owner, asserting any claims based on or related
        to the use of this website.</p>

      
    </div>
  )
}

function TermsAndConditions() {
  return(
    <div>
      <h1>Terms and Conditions</h1>
      <p>These terms and conditions outline the rules and regulations for the use of Waco Exchange's Website, located at WacoExchange.com.</p>
      <p>By accessing this website we assume you accept these terms and conditions. Do not continue to use Waco Exchange if you do not agree to take all of the terms and conditions stated on this page.</p>
      <p>The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements: "Client", "You" and "Your" refers to you, the person log on this website and compliant to the Company’s terms and conditions. "The Company", "Ourselves", "We", "Our" and "Us", refers to our Company. "Party", "Parties", or "Us", refers to both the Client and ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client’s needs in respect of provision of the Company’s stated services, in accordance with and subject to, prevailing law of Netherlands. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same.</p>
      <h2>Cookies</h2>
      <p>We employ the use of cookies. By accessing Waco Exchange, you agreed to use cookies in agreement with the Waco Exchange's Privacy Policy.</p>
      <p>Most interactive websites use cookies to let us retrieve the user’s details for each visit. Cookies are used by our website to enable the functionality of certain areas to make it easier for people visiting our website. Some of our affiliate/advertising partners may also use cookies.</p>
      
      <h2>YOU MUST BE 18 YEARS OR OLDER TO REGISTER AND USE OUR PLATFORM</h2>

      <h2>License</h2>
      <p>Unless otherwise stated, Waco Exchange and/or its licensors own the intellectual property rights for all material on Waco Exchange. All intellectual property rights are reserved. You may access this from Waco Exchange for your own personal use subjected to restrictions set in these terms and conditions.</p>
      <p>You must not:</p>
      <ul>
        <li>Republish material from Waco Exchange</li>
        <li>Sell, rent or sub-license material from Waco Exchange</li>
        <li>Reproduce, duplicate or copy material from Waco Exchange</li>
        <li>Redistribute content from Waco Exchange</li>
      </ul>
      <p>This Agreement shall begin on the date hereof.</p>
      <p>Parts of this website offer an opportunity for users to post and exchange opinions and information in certain areas of the website. Waco Exchange does not filter, edit, publish or review Comments prior to their presence on the website. Comments do not reflect the views and opinions of Waco Exchange,its agents and/or affiliates. Comments reflect the views and opinions of the person who post their views and opinions. To the extent permitted by applicable laws, Waco Exchange shall not be liable for the Comments or for any liability, damages or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the Comments on this website.</p>
      <p>Waco Exchange reserves the right to monitor all Comments and to remove any Comments which can be considered inappropriate, offensive or causes breach of these Terms and Conditions.</p>
      <p>You warrant and represent that:</p>
      <ul>
        <li>You are entitled to post the Comments on our website and have all necessary licenses and consents to do so;</li>
        <li>The Comments do not invade any intellectual property right, including without limitation copyright, patent or trademark of any third party;</li>
        <li>The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an invasion of privacy</li>
        <li>The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity.</li>
      </ul>
      <p>You hereby grant Waco Exchange a non-exclusive license to use, reproduce, edit and authorize others to use, reproduce and edit any of your Comments in any and all forms, formats or media.</p>

      <h2>Hyperlinking to our Content</h2>
      <p>The following organizations may link to our Website without prior written approval:</p>
      <ul>
        <li>Government agencies;</li>
        <li>Search engines;</li>
        <li>News organizations;</li>
        <li>Online directory distributors may link to our Website in the same manner as they hyperlink to the Websites of other listed businesses; and</li>
        <li>System wide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our Web site.</li>
      </ul>
      <p>These organizations may link to our home page, to publications or to other Website information so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products and/or services; and (c) fits within the context of the linking party’s site.</p>
      <p>We may consider and approve other link requests from the following types of organizations:</p>
      <ul>
        <li>commonly-known consumer and/or business information sources;</li>
        <li>dot.com community sites;</li>
        <li>associations or other groups representing charities;</li>
        <li>online directory distributors;</li>
        <li>internet portals;</li>
        <li>accounting, law and consulting firms; and</li>
        <li>educational institutions and trade associations.</li>
      </ul>

      <p>We will approve link requests from these organizations if we decide that: (a) the link would not make us look unfavorably to ourselves or to our accredited businesses; (b) the organization does not have any negative records with us; (c) the benefit to us from the visibility of the hyperlink compensates the absence of Waco Exchange; and (d) the link is in the context of general resource information.</p>
      <p>These organizations may link to our home page so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products or services; and (c) fits within the context of the linking party’s site.</p>
      <p>If you are one of the organizations listed in paragraph 2 above and are interested in linking to our website, you must inform us by sending an e-mail to Waco Exchange. Please include your name, your organization name, contact information as well as the URL of your site, a list of any URLs from which you intend to link to our Website, and a list of the URLs on our site to which you would like to link. Wait 2-3 weeks for a response.</p>
      <p>Approved organizations may hyperlink to our Website as follows:</p>
      <ul>
        <li>By use of our corporate name; or</li>
        <li>By use of the uniform resource locator being linked to; or</li>
        <li>By use of any other description of our Website being linked to that makes sense within the context and format of content on the linking party’s site.</li>
      </ul>
      <p>No use of Waco Exchange's logo or other artwork will be allowed for linking absent a trademark license agreement.</p>

      <h2>iFrames</h2>
      <p>Without prior approval and written permission, you may not create frames around our Webpages that alter in any way the visual presentation or appearance of our Website.</p>

      <h2>Content Liability</h2>
      <p>We shall not be hold responsible for any content that appears on your Website. You agree to protect and defend us against all claims that is rising on your Website. No link(s) should appear on any Website that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights.</p>

      <h2>Your Privacy</h2>
      <p>Please read our Privacy Policy</p>

      <h2>Reservation of Rights</h2>
      <p>We reserve the right to request that you remove all links or any particular link to our Website. You approve to immediately remove all links to our Website upon request. We also reserve the right to amen these terms and conditions and it’s linking policy at any time. By continuously linking to our Website, you agree to be bound to and follow these linking terms and conditions.</p>

      <h2>Removal of links from our website</h2>
      <p>If you find any link on our Website that is offensive for any reason, you are free to contact and inform us any moment. We will consider requests to remove links but we are not obligated to or so or to respond to you directly.</p>
      <p>We do not ensure that the information on this website is correct, we do not warrant its completeness or accuracy; nor do we promise to ensure that the website remains available or that the material on the website is kept up to date.</p>

      <h2>Disclaimer</h2>
      <p>To the maximum extent permitted by applicable law, we exclude all representations, warranties and conditions relating to our website and the use of this website. Nothing in this disclaimer will:</p>
      <ul>
        <li>limit or exclude our or your liability for death or personal injury;</li>
        <li>limit or exclude our or your liability for fraud or fraudulent misrepresentation;</li>
        <li>limit any of our or your liabilities in any way that is not permitted under applicable law; or</li>
        <li>exclude any of our or your liabilities that may not be excluded under applicable law.</li>
      </ul>
      <p>The limitations and prohibitions of liability set in this Section and elsewhere in this disclaimer: (a) are subject to the preceding paragraph; and (b) govern all liabilities arising under the disclaimer, including liabilities arising in contract, in tort and for breach of statutory duty.</p>
      <p>As long as the website and the information and services on the website are provided free of charge, we will not be liable for any loss or damage of any nature.</p>
    </div>
  )
}

function AdvertisingPolicy() {
  return(
    <div>
      <h1>Advertising Policy</h1>
      <p>We make our money through online advertising – which makes this site free for you to use. We’re not trying to pull a fast one or rip you off, but we do need to pay all of the talented people who work on this site. So we’ve adopted an advertising policy that works best for us and for you. If you have any questions, please contact us at wacoexchange@gmail.com</p>
      <ul>
        <li>We will not sell your personal details to a third party. Advertisers on our site have only two ways of tracking data, clicks and impressions.</li>
        <li>Waco Exchange reserves the right to decline any type of advertising that is damaging to the brand of Waco Exchange or is inappropriate to the content held on the Waco Exchange Network.</li>
        <li>Waco Exchange will not accept advertising for products or services known to be harmful to health (e.g. tobacco and alcohol products).</li>
        <li>Advertisements may not be deceptive or misleading, and must be verifiable. Advertisements should clearly identify the advertiser and the product or service being offered. Exaggerated or extravagantly worded copy will not be allowed. Advertisements will not be accepted if they appear to be indecent or offensive in either text or artwork, or if they relate to content of a personal, racial, ethnic, sexual orientation, or religious nature.</li>
      </ul>
    </div>
  )
}

function TrustFactorSystem() {
  return (
    <div>
      <h1>Trust-Factor System (TFS)</h1>
      <p>
        The Trust-Factor System helps reinforce Waco Exchange's community by ensuring common curtesy, policy compliance, and user-friendliness & safety throughout the platform. The TFS labels user account standings
        by Excellent, Good, Fair or Bad. Excellent being the user has not engaged in any harmful behavior towards any member of the community registered on Waco Exchange, whilst Bad account standing
        is alluding to account suspension or permanent termination.
      </p>
      <h2>TFS Violation Results</h2>
      <p>Accounts who receive more than 3 or more medium-to-low violations will result in account suspension.
        Users will be able to appeal account violations for second-reviewal, which will take 1-2 business days
        for a full investigation.
      </p>
      <p><b>Violation #1:</b></p>
      <p>If you receive your first violation, your public profile will reflect back to users
        as in Good Standing. This standing is still good, but because reports are justified and reviewed
        through the TFS, it means a user is lacking proper behavior. You can appeal your first violation
        to be removed from your account. A 24-hour account suspension will be enforced.
      </p>
      <p><b>Violation #2:</b></p>
      <p>Users with their second violation will be given an account status of Fair Standing. Meaning,
        this user is showing more than usual inappropriate behavior, or, they're untrustworthy.
        You cannot appeal the second violation. A 1-week account suspension will be enforced.
      </p>
      <p><b>Violation #3:</b></p>
      <p>Any user who inherits 3 account violations is considered a Threat to the Waco Exchange community.
        3rd time violators will result in a 1-month account suspension that will be enforced.
        Their account will remain as a threat until they can submit an appeal 3 months after the 1-month
        account suspension has lifted.
      </p>
      <p><b>Any violations after the 3rd violation will result in permanent account termination.</b></p>
      <h2>TFS Report Grading</h2>
      <p>
        TFS Reports are not limited to activities on Waco Exchange, if a user acts inappropriately
        during a meetup, they're subject to violations.
      </p>
      <p><b>Low Level Violation Offenses</b> general consist of and not limited to;</p>
      <ul>
        <li>Verbal indecency (Messaging)</li>
        <li>Low frequency spam posting</li>
        <li>Inconsistent information on posts</li>
      </ul>
      <p><b>Medium Level Violation Offenses</b> general consist of and not limited to;</p>
      <ul>
        <li>Inappropriate behavior (Messaging)</li>
        <li>Excessive spam posting</li>
        <li>Scammers</li>
        <li>Verbal threats</li>
      </ul>
      <p><b>High Level Violation Offenses</b> general consist of and not limited to;</p>
      <ul>
        <li>Illicit content</li>
        <li>Listings comprised of illegal activities</li>
        <li>Messages comprised of illegal activities</li>
        <li>Blatant scamming</li>
        <li>Death threats</li>
      </ul>
    </div>
  )
}